export default "__VITE_ASSET__cddfe6bb__"